export default {
  /**
   * Set list of available devices
   * @param {Object} state
   * @param {Object[]} sources
   */
  setSources(state, sources) {
    state.sources = sources;
  },
  /**
   * Set selected video source
   * @param {Object} state
   * @param {Object} source
   */
  setSelectedVideoSource(state, source) {
    state.selectedVideoSource = source;
  },
  /**
   * Set selected audio source
   * @param {Object} state
   * @param {Object} source
   */
  setSelectedAudioSource(state, source) {
    state.selectedAudioSource = source;
  },

  /**
   * Set device ready state
   * @param state {Object}
   * @param isReady {Boolean}
   */
  setReady(state, isReady) {
    state.isReady = isReady;
  },
  /** Set system supported by OT */
  setSystemSupported(state, isSupported) {
    state.systemSupported = isSupported;
  },
  /** Set video device available */
  setVideoDeviceAvailable(state, hasVideoDevice) {
    state.hasVideoDevice = hasVideoDevice;
  },
  /** Set device error from OT */
  setDeviceError(state, error) {
    state.deviceError = error;
  }
};
